import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ViewChildren,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { Routine, RoutineDevice } from "./routines.model";
import { RoutinesService } from "./routines.service";
import { DevicesService } from "../devices/devices.service";
import { Device } from "../devices/device.model";
import { GeneralService } from "../../shared/services/general.service";
import { SessionStateService } from "../../core/services/session-state.service";
import { AuthenticationService } from "../../core/services/authentication.service";
import { NewRoutinesCardComponent } from "./new-routines-card/new-routines-card.component";

@Component({
  selector: "app-routines",
  templateUrl: "./routines.component.html",
  styleUrls: ["./routines.component.scss"],
})
export class RoutinesComponent implements OnInit {
  menu: string[];
  loading;
  showNew = false;
  routinesLoading: boolean[] = [];
  routines: Routine[];
  devices: Map<string, Device>;
  updateThreadId;
  boxOn: boolean;
  _houseId: string = null;
  _userToken: string = null;
  selectedHouseIndex: number;
  clientHouses: any;
  noHouse: boolean;
  @ViewChild(NewRoutinesCardComponent) newRoutineCard: NewRoutinesCardComponent;

  constructor(
    private routinesService: RoutinesService,
    private devicesService: DevicesService,
    private sessionStateService: SessionStateService,
    private authenticationService: AuthenticationService,
    private generalService: GeneralService
  ) {}

  ngOnInit() {
    this.loading = true;
    this._houseId = this.sessionStateService.getHouse().houseId;
    this.generalService
      .getBoxConnectionStatus()
      .map((state) => {
        this.boxOn = state;
        this.initComponent();
      })
      .finally(() => (this.loading = false))
      .subscribe();
    this.generalService.connChange.subscribe((state) => {
      this.boxOn = state;
      if (state) {
        this.initComponent();
      }
    });
  }

  initComponent() {
    this.loading = true;
    return this.routinesService
      .getRoutines(this._houseId)
      .subscribe((response) => {
        this.routines = response.routines;
        this.showNew = true;
      })
      .add(() => {
        this.loading = false;
      });
  }

  getBoxConnectionStatus() {
    return this.boxOn;
  }

  refreshPage() {
    this.initComponent();
  }

  loadingStatus() {
    return this.loading;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/routines/routines.component.ts